import React, { useEffect } from 'react';
import { PageHero } from '../components/page/PageHero';
import { IncludedList } from '../components/page/IncludedList';
import { WhyLawyerLed } from '../components/page/WhyLawyerLed';
import { Process } from '../components/home/Process';
import { FeeTransparency } from '../components/page/FeeTransparency';
import { MiniFAQ } from '../components/page/MiniFAQ';
import { FinalCTA } from '../components/home/FinalCTA';
const INCLUDED = [{
  title: 'Contract of sale preparation',
  body: 'Your contract of sale is prepared correctly so the property can go to market without avoidable delay.'
}, {
  title: 'Vendor disclosure documents',
  body: 'The relevant disclosure documents are prepared for the property location and considered alongside the contract of sale.'
}, {
  title: 'Buyer enquiry management',
  body: 'Questions from buyers and their representatives are handled so the sale keeps moving.'
}, {
  title: 'Auction and private sale',
  body: 'Support whether you are selling by auction or private treaty, including contract readiness for auction day.'
}, {
  title: 'Settlement coordination',
  body: 'Documents, adjustments and settlement are coordinated through to completion.'
}, {
  title: 'One point of contact',
  body: 'You deal with the team handling your file directly throughout the sale.'
}];
const FAQS = [{
  q: 'What vendor disclosure documents are required?',
  a: 'Disclosure requirements differ between states and territories. The relevant documents should be prepared for the property location and considered together with the contract of sale.'
}, {
  q: 'When should I get the contract prepared?',
  a: 'Before you go to market. Having the contract and vendor statement ready means buyers can act when they are interested, rather than waiting on paperwork.'
}, {
  q: 'What does it cost?',
  a: 'You receive a clear scope and fee before any work begins. Send the details of your sale for a quote.'
}];
export function SellingProperty() {
  useEffect(() => {
    document.title = 'Selling Property in Australia | L.A Property Law';
    window.scrollTo(0, 0);
  }, []);
  return <main data-id="element-674" data-mp="jv15ot191noa">
      <PageHero eyebrow="selling property" title="Go to market with the paperwork done right." intro="Prepare the contract and vendor statement correctly, respond to buyer enquiries and keep the transaction moving toward settlement." primaryLabel="Get a free quote" primaryAction="quote" data-id="element-675" data-mp="ju7tvdnfo7za" />
      <IncludedList eyebrow="what is included" heading="Seller support from listing to settlement." intro="Your contract and vendor statement prepared properly, then coordinated management through to settlement." items={INCLUDED} data-id="element-676" data-mp="xsz60uiqjjks" />
      <WhyLawyerLed data-id="element-677" data-mp="1bnrskcx1m00v" />
      <Process data-id="element-678" data-mp="1bo9wlvpy5ijc" />
      <FeeTransparency variant="background" data-id="element-679" data-mp="1bkm2aucogs3k" />
      <MiniFAQ items={FAQS} data-id="element-680" data-mp="1gml8ebzsy347" />
      <FinalCTA data-id="element-681" data-mp="1gltc0yyds1cv" />
    </main>;
}